import { fileUrl } from '@/services';
import { fmtTime, activityColor } from '@/utils/format';

/** Thumbnail card for a tracker screenshot. Shared by the day view and the gallery. */
export default function ScreenshotTile({ shot, onClick, showUser = false }) {
  const pct = Math.round(shot.activityPercent || 0);
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-left rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden hover:border-brand-400 hover:shadow-card transition"
    >
      <div className="aspect-video bg-slate-100 dark:bg-slate-800">
        <img
          src={fileUrl(shot.thumb || shot.file)}
          alt={shot.activeTitle || 'Screenshot'}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-2.5">
        {showUser && shot.user && <div className="text-xs font-medium truncate">{shot.user?.name}</div>}
        <div className="flex items-center justify-between gap-2 text-xs">
          <span className="text-slate-500">{fmtTime(shot.capturedAt)}</span>
          <span className="inline-flex items-center gap-1">
            <span className={`w-2 h-2 rounded-full ${activityColor(pct)}`} />
            <span className="text-slate-500">{pct}%</span>
          </span>
        </div>
        <div className="text-xs text-slate-400 truncate mt-0.5">{shot.activeApp || 'Unknown app'}</div>
      </div>
    </button>
  );
}
